import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { isEqual, set } from 'lodash';
import { NgxPermissionsService } from 'ngx-permissions';
import { PrimeNGConfig } from 'primeng/api';
import { of, switchMap } from 'rxjs';
import { CustomTranslateService } from 'src/app/core/services/custom-translate.service';
import { environment } from 'src/environments/environment';
import { MarketPlaceService } from '../../services/market-place.service';

export const STATE_RENDER_APP = {
  INIT: 'INIT',
  IFRAME: 'IFRAME',
  APP: 'APP',
};

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  public env: any = { ...environment };
  smallScreen = 1439;
  isSmallScreen: boolean = false;
  sidebarVisible: boolean = false;
  // DOMAIN
  stateView: string = STATE_RENDER_APP.INIT;
  adminHubApp: string = environment.ADMIN_HUB_URL;

  // DEV
  //stateView: string = STATE_RENDER_APP.APP;
  user: any;
  translator = inject(CustomTranslateService);

  constructor(
    private primeNgConfig: PrimeNGConfig,
    private translateService: TranslateService,
    public readonly http: HttpClient,
    private ngxPermissionsService: NgxPermissionsService,
    private marketPlaceService: MarketPlaceService,
  ) {
    this.env.baseURL = this.env.BASE_API_URL;
    window.addEventListener('message', this.handleReceiveMessage);
    // this.loadPermissionList(localStorage.getItem('accessToken')!);
  }

  ngOnInit() {
    this.checkSmallScreen();
    window.addEventListener('resize', () => this.checkSmallScreen());

    this.translateService.onLangChange
      .pipe(
        switchMap((event: LangChangeEvent) => {
          const res = this.translateService.getParsedResult(
            event.translations,
            'primeng',
          );
          return of(res);
        }),
      )
      .subscribe((res: any) => {
        const translations = this.applyPrimeNgTranslations(res);
        this.primeNgConfig.setTranslation(translations);
      });
    const marketPlace = localStorage.getItem('marketplace');

    if (
      marketPlace &&
      !isEqual(JSON.parse(marketPlace ?? ''), this.marketPlaceService.data)
    ) {
      this.marketPlaceService.marketPlace$.next(JSON.parse(marketPlace));
    }
  }

  applyPrimeNgTranslations(translations: any): any {
    switch (typeof translations) {
      case 'function':
        return translations();
      case 'object':
        if (Array.isArray(translations)) {
          return translations.map((t) => this.applyPrimeNgTranslations(t));
        }
        for (const key in translations) {
          if (key) {
            translations[key] = this.applyPrimeNgTranslations(
              translations[key],
            );
          }
        }
        return translations;
      default:
        return translations;
    }
  }

  onActivate() {
    window.scroll({
      top: 0,
      left: 0,
    });
  }

  handleReceiveMessage = (e: MessageEvent) => {
    if (e?.data?.type === 'authorized' && e.origin === this.adminHubApp) {
      const accessTokenData = e.data?.token?.accessToken;
      const profileData = JSON.parse(e.data?.profile);
      if (accessTokenData && profileData) {
        localStorage.setItem('accessToken', accessTokenData);
        localStorage.setItem('auth', JSON.stringify(profileData));
        localStorage.setItem(environment.USER_PROFILE, e.data.profile);
        localStorage.setItem(
          environment.AUTH_STATUS,
          JSON.stringify({ isLoggedIn: true }),
        );
        this.user = profileData;
        this.user.avatarURL = `${environment.BE_URL}storage/files/web/${this.user?.avatar_thumbnail_url}.webp`;
        setTimeout(() => {
          this.loadPermissionList(accessTokenData);
        }, 100);
      } else {
        localStorage.setItem(
          environment.AUTH_STATUS,
          JSON.stringify({ isLoggedIn: false }),
        );
        window.location.href = `${environment.ADMIN_HUB_URL}/login?r=${environment.FE_URL}`; // => COMMENT WHILE DEV
      }
    } else if (e.data.type === 'unauthorized') {
      localStorage.setItem(
        environment.AUTH_STATUS,
        JSON.stringify({ isLoggedIn: false }),
      );
      window.location.href = `${environment.ADMIN_HUB_URL}/login?r=${environment.FE_URL}`; // => COMMENT WHILE DEV
    }
  };

  private loadPermissionList(accessTokenData: string) {
    const headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + accessTokenData,
    );
    this.http
      .get<any>(
        `${environment.BASE_API_URL}/user/admin-permissions/hub/CAR_MODULE_ADMIN/permission?countryCode=${this.marketPlaceService?.data?.root}`,
        {
          headers,
        },
      )
      .subscribe((res) => {
        this.ngxPermissionsService.loadPermissions(res.data);
        this.stateView = STATE_RENDER_APP.APP;
      });
  }

  checkSmallScreen() {
    this.isSmallScreen = window.innerWidth <= this.smallScreen;
  }

  changeMarketplace(event: Event) {
    const currentMarketPlace = localStorage.getItem('marketplace');

    if (!isEqual(JSON.parse(currentMarketPlace ?? ''), event)) {
      const token = localStorage.getItem('accessToken') ?? '';
      this.marketPlaceService.marketPlace$.next(event);
      this.loadPermissionList(token);
    }
  }

  changeLanguage(language: string) {
    this.translator.setLanguage(language.toLocaleLowerCase());
  }
}
